import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 55 44"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M8.25 19.25c3.034 0 5.5-2.466 5.5-5.5s-2.466-5.5-5.5-5.5a5.505 5.505 0 0 0-5.5 5.5c0 3.034 2.466 5.5 5.5 5.5m38.5 0c3.034 0 5.5-2.466 5.5-5.5s-2.466-5.5-5.5-5.5a5.505 5.505 0 0 0-5.5 5.5c0 3.034 2.466 5.5 5.5 5.5M49.5 22H44c-1.513 0-2.879.61-3.876 1.598 3.463 1.9 5.921 5.329 6.454 9.402h5.672A2.747 2.747 0 0 0 55 30.25V27.5c0-3.034-2.466-5.5-5.5-5.5m-22 0a9.62 9.62 0 0 0 9.625-9.625A9.62 9.62 0 0 0 27.5 2.75a9.62 9.62 0 0 0-9.625 9.625A9.62 9.62 0 0 0 27.5 22m6.6 2.75h-.713c-1.788.86-3.773 1.375-5.887 1.375s-4.09-.516-5.887-1.375H20.9c-5.466 0-9.9 4.434-9.9 9.9v2.475a4.126 4.126 0 0 0 4.125 4.125h24.75A4.126 4.126 0 0 0 44 37.125V34.65c0-5.466-4.434-9.9-9.9-9.9m-19.224-1.152A5.48 5.48 0 0 0 11 22H5.5A5.505 5.505 0 0 0 0 27.5v2.75A2.747 2.747 0 0 0 2.75 33h5.663c.542-4.073 3-7.502 6.463-9.402"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }